import { Component, Input } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { UserListService } from 'src/app/services/user-list/user-list.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent {

  constructor(
    private userListService:UserListService,
    public globalservice : GlobalService
    ){}

  user_id:string = "";
  isOpen:boolean = false;
  isLoading:boolean = false;
  userDetails:any;

  openModal(){ this.isOpen = true;}
  closeModal(){ this.isOpen = false;}
  
  async getUserDetails(userData:string){
      this.userDetails = userData;
      console.log(this.userDetails);
    
    
  }
}
